import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

/**
 * The one quiet, centred empty message for lists, feeds and grids. A section
 * that invites a first step adds a title above the message and the step below.
 */
export function EmptyState({
  children,
  className,
  variant = "list",
  title,
  action,
}: {
  children: ReactNode;
  className?: string;
  variant?: "list" | "section";
  /** Names what is missing, above the message. */
  title?: ReactNode;
  /** The first step, under the message. */
  action?: ReactNode;
}) {
  const frame = cn(
    "px-4 text-center text-sm text-muted-foreground",
    variant === "section"
      ? "flex min-h-20 items-center justify-center rounded-lg border border-dotted border-border py-6"
      : "py-12",
    className,
  );
  if (!title && !action) return <p className={frame}>{children}</p>;
  return (
    <div className={cn(frame, "flex flex-col items-center justify-center gap-1")}>
      {title ? <p className="font-medium text-foreground">{title}</p> : null}
      <p className="max-w-md text-balance">{children}</p>
      {action ? (
        <div className="mt-3 flex flex-wrap justify-center gap-2">{action}</div>
      ) : null}
    </div>
  );
}
